import { ApplicationConfig, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import {
  AuthenticationService,
  initializeKeyStates,
  KeycloakAuthenticationService,
  provideConfigFromUri,
  provideDefaultKeycloak,
} from '@ps-gui/shared-core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { DashboardConfig } from '@ps-gui/dashboard-shared-lib';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: AuthenticationService,
      useClass: KeycloakAuthenticationService,
    },
    MessageService,
    provideHttpClient(withFetch(), withInterceptors([includeBearerTokenInterceptor])),
    provideAppInitializer(() => initializeKeyStates()),
    provideConfigFromUri<DashboardConfig>('./assets/config/config.json'),
    provideDefaultKeycloak(),
    provideRouter(appRoutes),
  ],
};
